// src/config/bidit.js

// This file defines the data structure and options specific to the Bidit application.

export const customerFormConfig = {
  fields: {
    companyName: { label: 'Company Name', required: false },
    contactPerson: { label: 'Contact Person', required: true },
    phoneNumber: { label: 'Phone Number', required: false },
    emailAddress: { label: 'Email Address', required: true },
    website: { label: 'Website', required: false },
    streetAddress: { label: 'Street Address', required: false },
    city: { label: 'City', required: false },
    state: { label: 'State', required: false },
    postalCode: { label: 'Postal Code', required: false },
    country: { label: 'Country', required: false, defaultValue: 'US' },
    customerType: { label: 'Customer Type', required: false },
    businessSize: { label: 'Business Size', required: false },
    industry: { label: 'Industry', required: false },
    creditLimit: { label: 'Credit Limit', required: false },
    paymentTerms: { label: 'Payment Terms', required: false },
    assignedSalesperson: { label: 'Assigned Salesperson', required: false },
    territory: { label: 'Territory', required: false },
    customerSource: { label: 'Customer Source', required: false },
    notes: { label: 'Notes', required: false },
  },
  dropdowns: {
    customerTypes: [
      { value: 'residential', label: 'Residential' },
      { value: 'commercial', label: 'Commercial' },
      { value: 'industrial', label: 'Industrial' },
      { value: 'government', label: 'Government' },
    ],
    businessSizes: [
      { value: 'small', label: 'Small (1-50 employees)' },
      { value: 'medium', label: 'Medium (51-200 employees)' },
      { value: 'large', label: 'Large (200+ employees)' },
    ],
    industries: [
      { value: 'construction', label: 'Construction' },
      { value: 'renovation', label: 'Renovation' },
      { value: 'new_build', label: 'New Build' },
      { value: 'retrofit', label: 'Retrofit' },
      { value: 'maintenance', label: 'Maintenance' },
    ],
    paymentTermsOptions: [
      { value: 'net_30', label: 'Net 30' },
      { value: 'net_60', label: 'Net 60' },
      { value: 'net_90', label: 'Net 90' },
      { value: 'cod', label: 'COD' },
      { value: 'prepaid', label: 'Prepaid' },
    ],
    customerSources: [
      { value: 'referral', label: 'Referral' },
      { value: 'website', label: 'Website' },
      { value: 'trade_show', label: 'Trade Show' },
      { value: 'phone_call', label: 'Phone Call' },
      { value: 'email', label: 'Email' },
      { value: 'walk_in', label: 'Walk-in' },
    ],
  },
};
